const apis = {
    apiTip: '거래 요구를 충족시키기 위해 API 키를 생성합니다. 자산의 안전을 위해 API 키를 누출하지 마십시오.',
    cjapi: 'API 생성',
    bzm: '비고명',
    qx: '권한',
    cjrq: '생성 날짜',
    cz: '작업',
    ck: '보기',
    bj: '편집',
    sc: '삭제',
    mm: '암호 (Passphrase)',
    qsrmm: '암호를 입력하세요 (Passphrase)',
    sjyzm: '휴대폰 인증 코드',
    qsryzm: '인증 코드를 입력하세요',
    yxyzm: '이메일 인증 코드',
    dzbmd: 'IP 주소 화이트리스트 (선택 사항)',
    my: '비밀 키',
    cancel: '취소',
    confirm: '확인',
    fzapi: 'API 정보 복사',
    qdsc: '{name} API를 삭제하시겠습니까?',
    tip: '팁',
    sccg: '삭제 성공!',
    yqxsc: '삭제 취소됨',
    tips: '참고:',
    zdcy: '각 메인 계정 및 하위 계정은 최대 50개의 활성 API 키를 보유할 수 있습니다.',
    qwxl: 'API 키를 누출하지 마십시오. API 키를 IP에 바인딩하면 보안이 크게 향상됩니다.',
    dsfbd: '거래 및 출금 권한을 가진 API를 타사 플랫폼에 바인딩하면 API 정보가 누출될 수 있으므로 신중히 작업하십시오.',
    zdsc: '자금의 안전을 위해 IP 주소에 바인딩되지 않고 거래 또는 출금 권한이 있는 API 키는 14일 동안 사용되지 않으면 자동으로 삭제되며, 다시 신청해야 합니다. IP에 바인딩되거나 읽기 전용 권한만 있는 API 키는 유효 기간이 없습니다.',
    dq: '읽기',
    jy: '거래',
    ljcj: '지금 생성',
    qsrbzm: '비고명을 입력하세요',
    cjcg: '생성 성공',
    czapi: 'API 재설정',
    cjlc: 'API 키 생성 클릭 > 자신의 API 키 및 관련 정보 생성 > API 문서 세부 정보 보기 > 개발 및 거래 수행',
    zdbddz: '각 API 키는 최대 20개의 IP 주소를 바인딩할 수 있으며, 여러 IP 주소를 추가하려면 반각 쉼표로 구분하십시오.',
    xgcg: '수정 성공',
  }
  
export {
    apis
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/api/kr.js